import { render, staticRenderFns } from "./InformeCategoriasTab.vue?vue&type=template&id=991c14e4"
import script from "./InformeCategoriasTab.vue?vue&type=script&setup=true&lang=js"
export * from "./InformeCategoriasTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports